export const en = {
  utility: {
    choose: "Choose a utility tool",
    utility: "Utility",
  },
  navigation: {
    utility: "Utility",
  },
  toast: {
    error: {},
    success: {
      utilityDone: "Operation done successfully",
    },
    warning: {},
  },
};
